import onboardingMain from './onboardingMain';

export default onboardingMain;
